<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading">
    <div class="flex flex-row pt-0 mb-7 gap-5 cursor-pointer">
        <p class="font-semibold text-[#424242] dark:text-white">Profile</p>
        <p class="font-semibold text-[#424242] dark:text-white" (click)="back()">View My Target</p>
        <p class="font-semibold text-[#424242] dark:text-white">Edit My Targets</p>
    </div>

<div
  class="w-full h-full min-h-screen px-10 py-7 bg-tileLight dark:bg-tileBlack shadow-lg rounded-lg "
>
    

  <div class="flex flex-col items-center justify-center my-4">
    <p class="text-lg text-black dark:text-textDark font-bold my-2">
      EMP ID : {{ targetObj.empId }}
    </p>
  </div>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 mt-5">
    <div>
      <label
        for="varietyNameEnglish"
        class="block text-sm font-semibold text-[#534E4E] dark:text-textDark"
        >Variety Name :</label
      >
      <input
        id="varietyNameEnglish"
        [value]="targetObj.varietyNameEnglish"
        disabled
        class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-tileBlack"
      />
    </div>

    <div>
      <label
        for="todo"
        class="block text-sm font-semibold text-[#534E4E] dark:text-textDark"
        >The Maximum Amount You Can Pass (kg) :</label
      >
      <input
        id="todo"
        [value]="targetObj.todo"
        disabled
        class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-tileBlack"
      />
    </div>
  </div>

  <hr class="border-b-1 border-[#BDBDBD] my-5" />

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 ">
    <div>
      <label
        for="variety"
        class="block text-sm font-semibold text-[#534E4E] dark:text-textDark mb-1"
      >
        Select Short Stock Assignee :
      </label>

      <app-searchable-dropdown [items]="officerDropdownItems" placeholder="Select Officer"
        searchPlaceholder="Search Officers..." [(ngModel)]="selectedOfficerId"
        (selectionChange)="onOfficerSelectionChange($event)" [clearable]="true" [showSelected]="true"
        [disabled]="false" borderClass="border-gray-300 border-[1px]" class="block w-full mb-4"></app-searchable-dropdown>
        
    </div>

    <div>
      <label
        for="passAmount"
        class="block text-sm font-semibold text-[#534E4E] dark:text-textDark"
        >The Amount (kg) :</label
      >
      <div class="mt-1 flex border border-gray-300 rounded-md overflow-hidden bg-tileLight dark:bg-tileBlack">
        <input
          id="passAmount"
          name="passAmount"
          type="text"
          inputmode="numeric"
          [value]="passAmount"
          (input)="onPassAmountInput($event)"
          (blur)="enforceMinAmount()"
          class="flex-1 p-2 h-[42px] text-textLight dark:text-textDark bg-transparent outline-none min-w-0"
        />
        <div class="flex flex-col w-5 shrink-0 border-l border-gray-300 dark:border-gray-600">
          <button type="button" (click)="incrementAmount()"
            class="flex flex-1 items-center justify-center hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 border-b border-gray-300 dark:border-gray-600">
            <svg viewBox="0 0 10 6" class="w-2 h-2 fill-current"><path d="M5 0L10 6H0Z"/></svg>
          </button>
          <button type="button" (click)="decrementAmount()"
            class="flex flex-1 items-center justify-center hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500">
            <svg viewBox="0 0 10 6" class="w-2 h-2 fill-current"><path d="M5 6L0 0H10Z"/></svg>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-row justify-center items-center gap-12 my-10">
    <button
      class="text-[#6B7D8C] bg-[#F6F7F9] border-[#6B7D8C] border-[1px] rounded-lg shadow-md px-4 py-2"
      (click)="onCancel()"
    >
      Cancel
    </button>
    <button
      class="bg-[#415CFF] text-white rounded-lg shadow-md px-6 py-2"
      (click)="onSubmit()"
    >
      Save
    </button>
  </div>
</div>
</div>
